/**
 *
 * RadioButtonDivision
 *
 */

import React from "react"
import PropTypes from "prop-types"
import "./index.less"
import { Radio, Button } from "antd"
import { buttonAction_btns } from "../Snowplow/config2"
/* eslint-disable react/prefer-stateless-function */
class RadioButtonDivision extends React.Component {
  state = { view: "1" }
  componentDidMount = () => {
    if(this.props.rows.length==0){
      this.props.toggleModal("buttonDeleteDivisions", false)
    }
  }
  handleChange = (e) => {
    this.props.toggleTableView(e.target.value)
    if (e.target.value == 2) buttonAction_btns("Vista árbol divisiones")
  }

  render() {
    return (
      <div>
        <Radio.Group
          onChange={this.handleChange}
          value={this.props.tableView}
          className="radioButtons">
          <Radio.Button value="1">Listado</Radio.Button>
          <Radio.Button value="2">Árbol</Radio.Button>
        </Radio.Group>
      </div>
    )
  }
}

RadioButtonDivision.propTypes = {}

export default RadioButtonDivision
